// TODO: move to send a form feature

export enum LinkType {
  Template = 0,
  Form = 1
}

export enum ShareType {
  Url = 0,
  Email = 1,
  Text = 2
}

export enum ViewType {
  FormView = 0,
  ListView = 1
}

/** This is duplicated in publicshare/publicshare-types.ts */
export enum ValidationType {
  None = 0,
  Email = 1,
  PhoneNumber = 2
}
